import { WeakValidationMap } from 'react';

const protectedProps = ['alias', 'slot', 'uuid', 'onMount', 'onUnmount'];

function getLostProps<P>(propTypes: WeakValidationMap<P>, props: P): object {
  if (!propTypes) {
    return {};
  }
  
  const entries = Object.entries(props);
  
  return entries
    .filter(([key]) => !protectedProps.includes(key))
    .reduce(
      (result, [key, value]) =>
        key in propTypes ? result : { ...result, [key]: value },
      {}
    );
}

export default getLostProps;
